import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Grid, Col, Row, Form, FormGroup, FormControl,
  ControlLabel, Button } from 'react-bootstrap'
import { constants } from '../../redux/lessons/actions'
import { commonConstants } from '../../redux/common/actions'
import NotificationSystem from 'react-notification-system'
import { style as notificationStyling } from '../../variables/Variables.jsx'
import { getFormattedUser } from '../../services/auth'
import moment from 'moment'
import Card from "components/Card/Card.jsx";
import { Checkbox } from '@material-ui/core'

const { UPDATE_LESSON_FORM_FIELD, SUBMIT_LESSON_FORM, FETCH_LESSON,
  UPDATE_LESSON, ADD_QUESTION, REMOVE_QUESTION, UPDATE_QUESTION,
  ADD_ANSWER, REMOVE_ANSWER, UPDATE_ANSWER, UPDATE_ANSWER_DESCRIPTION, UPDATE_QUESTION_DESCRIPTION,
  UPDATE_ANSWER_CORRECT, RESET_LESSON_FORM_FIELDS
 } = constants
const { REQUEST } = commonConstants



const LessonForm = ({ match }) => {
  const { loading, error, success, ...form } = useSelector(state => state.lessons)

  // const breakpoints = { xs: 0, sm: 425, md: 1024 }
  // const { size } = useResponsive(breakpoints)
  // const radioStyle = size === 'xs' ? { transform: 'scale(3)', margin: 16 } : {}

  const dispatch = useDispatch()
  const notificationSystem = useRef()
  const [_notificationSystem, setNotificationSystem] = useState({})
  const searchParams = new URLSearchParams(window.location.search)
  const readOnlyMode = searchParams.has('readOnly') && searchParams.get('readOnly') === 'true'
  const [, setHasAdmin] = useState(false)
  const [, setHasEdit] = useState(false)

  // initial page fetch
  useEffect(() => {
    dispatch({ type: RESET_LESSON_FORM_FIELDS, payload: {} })
    if (match.params.id) { dispatch({ type: FETCH_LESSON + REQUEST, payload: { id: match.params.id } }) }
    setNotificationSystem(notificationSystem)
    return () => {}
  }, [])

  // handle ajax side effects
  useEffect(() => {
    const notificationSystem = _notificationSystem.current
    if (notificationSystem && success.message) { notificationSystem.addNotification({ message: success.message, level: 'info', position: 'tc' }) }
    if (notificationSystem && error.message) { notificationSystem.addNotification({ message: error.message, level: 'error', position: 'tc' }) }
    return () => {}
  }, [success.message, error.message])

  // handle scroll to top for notifications
  useEffect(() => {
    // THIS IS SCREWY - Desktop works fine, Mobile scrolls to top quickly then back to original position - 2x fixed this
    document.getElementById('top-of-the-form-to-ya').scrollIntoView(true)
    document.getElementById('top-of-the-form-to-ya').scrollIntoView(true)
    return () => {}
  }, [success.message, error.message])

  // retrieve user
  const [callTakerId, setCallTakerId] = useState(null)
  const [callTakerName, setCallTakerName] = useState(null)

  useEffect(() => {
    const getUser = async() => {
      const user = await getFormattedUser()
      const hasAdmin = user && user.roles && user.roles.includes('SuperAdmin')
      const hasEdit = user && user.roles && user.roles.includes('ProviderQuestionnaireAdmin')
      setHasAdmin(hasAdmin)
      setHasEdit(hasEdit)
      setCallTakerId(user.id)
      setCallTakerName(user.fullName)
    }
    getUser().then()
  }, [])

  const { title, description, video_url, document_url, questions } = form

  const formattedPayload = { ...form, callTakerId, name: callTakerName }
  const submitRoute = match.params.id > 0 ? UPDATE_LESSON : SUBMIT_LESSON_FORM

  const date = moment().format('MMMM DD, YYYY')

  // if (loading.source === FETCH_LESSON) {
  //   return (
  //     <div className='main-content' style={{ textAlign: 'center' }}>
  //       <ClipLoader loading size={50} color="grey" />
  //     </div>
  //   )
  // }

  // QUESTIONS
  const addQuestion = () => {
    dispatch({ type: ADD_QUESTION + REQUEST })
  }
  const updateQuestion = (index, event) => {
    dispatch({ type: UPDATE_QUESTION + REQUEST, payload: { index, text: event.target.value } })
  }
  const updateQuestionDescription = (index, event) => {
    dispatch({ type: UPDATE_QUESTION_DESCRIPTION + REQUEST, payload: { index, text: event.target.value } })
  }
  // const updateQuestionType = (index, event) => {
  //   dispatch({ type: UPDATE_QUESTION_TYPE + REQUEST, payload: { index, value: event.value } })
  // }
  const removeQuestion = (index) => {
    dispatch({ type: REMOVE_QUESTION + REQUEST, payload: { index } })
  }

  // ANSWERS
  const addAnswer = (question_index) => {
    dispatch({ type: ADD_ANSWER + REQUEST, payload: { question_index }})
  }
  const updateAnswer = (question_index, index, event) => {
    dispatch({ type: UPDATE_ANSWER + REQUEST, payload: { question_index, index, text: event.target.value } })
  }
  const updateAnswerDescription = (question_index, index, event) => {
    dispatch({ type: UPDATE_ANSWER_DESCRIPTION + REQUEST, payload: { question_index, index, text: event.target.value } })
  }
  const updateAnswerCorrect = (question_index, index, event) => {
    console.log("updating correctness",  event.currentTarget.checked)
    dispatch({ type: UPDATE_ANSWER_CORRECT + REQUEST, payload: { question_index, index, value: event.currentTarget.checked } })
  }
  const removeAnswer = (question_index, index) => {
    dispatch({ type: REMOVE_ANSWER + REQUEST, payload: { question_index, index } })
  }

  const renderQuestions = () => {
    return questions.map((prop, index) => {
      return (
        <Card
          key={'question-card' + index}
          content={
            <Row>
                <Grid fluid>
                  <Row>
                    <Col xs={12} sm={12}>
                      <FormGroup>
                        <ControlLabel>
                          <b style={{marginRight: 10}}>Question #{index + 1}</b>

                          <Button
                            className='ml-4'
                            onClick={() => removeQuestion(index)}
                            bsStyle="danger"
                            bsSize='small'
                          >
                              <i className="pe-7s-trash action-icon" />
                          </Button>
                        </ControlLabel>
                        {/* <Row style={{marginLeft: 10, maxWidth: 200}}>
                          <FormGroup>
                            <ControlLabel>Question Type</ControlLabel>
                            <Select
                              options={[
                                { label: 'single', value: 'single'},
                                { label: 'multi', value: 'multi'}
                              ].map( qt => {
                                return { label: qt.label, value: qt.value }
                              })}
                              value={{ label: prop.question_type, value: prop.question_type }}
                              isSearchable={false}
                              name='question_type'
                              onChange={event => updateQuestionType(index, event)}
                            />
                          </FormGroup>
                        </Row> */}

                        <Row style={{marginLeft: 10, marginBottom: 10}}>
                          <span>Question</span>
                          <FormControl
                            componentClass='input'
                            id={'question-' + index}
                            name='question'
                            value={prop.question}
                            placeholder='Question - Text'
                            // style={{ height: '200px' }}
                            onChange={(event) => updateQuestion(index, event)}
                          />
                        </Row>

                        <Row style={{marginLeft: 10}}>
                          <span>Description (Optional)</span>
                          <FormControl
                            componentClass='textarea'
                            id={'question-description-' + index}
                            name='question-description'
                            placeholder='Description (Optional) - Add more descriptive text to the question here.'
                            value={prop.questionDescription}
                            // style={{ height: '200px' }}
                            onChange={(event) => updateQuestionDescription(index, event)}
                          />
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>
                </Grid>
                {renderAnswers(index, prop.answers)}
                <Button
                  onClick={() => addAnswer(index)}
                  bsStyle="warning"
                  style={{marginLeft: 20}}
                >
                  Add Answer
                </Button>
              {/* {hasAdmin &&
                <Col style={{marginLeft: 20}}>
                  <div className="actions-center">
                    <Button
                      onClick={() => removeQuestion(index)}
                      bsStyle="warning"
                      simple icon>
                      <i className="pe-7s-trash action-icon" />
                    </Button>{" "}
                  </div>
                </Col>
              } */}
            </Row>
          }
        />
      )
    })
  }

  const renderAnswers = (question_index, answers) => {
    return answers.map((prop, index) => {
      return (
            <Row
              className='ml-4'
              key={'answer-row' + index}
            >
                <Grid fluid>
                  <Row>
                    <Col xs={12} sm={12} style={{marginLeft: 30}}>
                      <FormGroup>
                        <ControlLabel>
                          <b style={{marginRight: 10}}>Answer #{index + 1}</b>
                          <Button
                            className='ml-3'
                            onClick={() => removeAnswer(question_index, index)}
                            bsStyle="danger"
                            bsSize='small'
                          >
                            <i className="pe-7s-trash action-icon" />
                          </Button>
                        </ControlLabel>
                        <Row style={{marginLeft: 10, marginBottom: 10}}>
                          <span>Answer</span>
                          <FormControl
                            componentClass='input'
                            id={'answer-' + index}
                            name='answer'
                            placeholder='Answer - Text'
                            value={prop.answer}
                            // style={{ height: '200px' }}
                            onChange={(event) => updateAnswer(question_index, index, event)}
                          />
                        </Row>
                        <Row style={{marginLeft: 10, marginBottom: 10}}>
                          <span>Description (Optional)</span>
                          <FormControl
                            componentClass='input'
                            id={'answer-description-' + index}
                            name='answer-description'
                            placeholder='Description (Optional) - Why is this answer right or wrong?'
                            value={prop.description}
                            // style={{ height: '200px' }}
                            onChange={(event) => updateAnswerDescription(question_index, index, event)}
                          />
                        </Row>
                      </FormGroup>

                      <Row style={{marginLeft: 10, marginBottom: 10}}>

                        <Checkbox
                          id={'answer-correct-1-' + index}
                          // checked={true}
                          name="answer-correct-1"
                          onChange={(event) => updateAnswerCorrect(question_index, index, event)}
                          checked={prop.correct}
                          label={'Correct'}
                          size='medium'
                          // style={radioStyle}
                        />
                        <span>Correct Answer</span>
                      </Row>
                    </Col>
                    <Col>

                    </Col>
                  </Row>
                </Grid>
            </Row>
      )
    })
  }

  return (
    <div className='main-content'>
      <NotificationSystem ref={notificationSystem} style={notificationStyling} />
      <Form>
        <Grid fluid>
          <Row>
            <Col xs={12} sm={6}>
              <FormGroup>
                <ControlLabel>Date</ControlLabel>
                <FormControl
                  type='input'
                  id='date'
                  name='date'
                  value={date}
                  disabled={true}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <FormGroup>
                <ControlLabel>Title</ControlLabel>
                <FormControl
                  type='input'
                  id='title'
                  name='title'
                  value={title}
                  onChange={event => handleChange(dispatch, event)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12}>
              <FormGroup>
                <ControlLabel>Description</ControlLabel>
                <FormControl
                  type='textarea'
                  id='description'
                  name='description'
                  value={description}
                  onChange={event => handleChange(dispatch, event)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12}>
              <FormGroup>
                <ControlLabel>Video Url</ControlLabel>
                <FormControl
                  componentClass='input'
                  id='video_url'
                  name='video_url'
                  value={video_url ? video_url : ''}
                  onChange={event => handleChange(dispatch, event)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12}>
              <FormGroup>
                <ControlLabel>Document Url (Optional)</ControlLabel>
                <FormControl
                  componentClass='input'
                  id='document_url'
                  name='document_url'
                  value={document_url ? document_url : ''}
                  onChange={event => handleChange(dispatch, event)}
                />
              </FormGroup>
            </Col>
          </Row>


          <Row>
            <Col xs={12} sm={12}>
              {renderQuestions()}
              <Button
                onClick={() => addQuestion()}
                bsStyle="danger"
              >
                Add Question
              </Button>
            </Col>
          </Row>

          {!readOnlyMode &&
            <Row style={{marginTop: 20}}>
              <Col xs={12} sm={12}>
                <Button
                  style={{ marginRight: '15px' }}
                  bsStyle='primary'
                  bsSize="lg"
                  onClick={() => dispatch({ type: submitRoute + REQUEST, payload: formattedPayload })}
                >
                  {match.params.id > 0 ? 'Save' : 'Submit'}
                </Button>
                <Button
                  bsStyle='warning'
                  type='reset'
                  bsSize="lg"
                  onClick={() => {window.location.href = "/admin/professional-development"}}
                >
                  Back
                </Button>
              </Col>
            </Row>
          }
        </Grid>
      </Form>
    </div>
  )
}

function handleChange (dispatch, event, formField) {
  let field = null
  let value = null
  if (formField === 'dateVerified') {
    field = formField
    value = event._d
  } else if (event.target) {
    field = event.target.name
    value = event.target.value
    value = value === "true" ? true : value
    value = value === "false" ? false : value
  } else { // select form items
    field = formField
    value = event
  }
  return dispatch({ type: UPDATE_LESSON_FORM_FIELD,  field, value})
}

export default LessonForm